<template>
  <MeteringPointCard :metering-point class="p-4 md:p-6">
    <div class="flex flex-col justify-between gap-8 xl:flex-row">
      <!-- Info list -->
      <div class="space-y-4">
        <TextSubtitle>Installatie</TextSubtitle>
        <AssetInfoListComponent :metering-point />
        <TextSubtitle class="!mt-6">Allocatiepunt</TextSubtitle>
        <AllocationPointInfoListComponent :metering-point="allocationPoint" />
      </div>
      <!-- Map image -->
      <div
        v-if="!viewStore.anonymize && address"
        class="flex flex-col gap-4 lg:max-w-96"
      >
        <div class="aspect-[3/2]">
          <LoadingWrapper :loading="!mapImage || false">
            <img
              class="rounded-lg"
              :src="mapImage"
              alt="Satellietafbeelding van de installatielocatie"
            />
          </LoadingWrapper>
        </div>
        <a
          :href="`https://www.google.com/maps/@?api=1&map_action=map&center=${address.latitude},${address.longitude}&zoom=17&basemap=satellite`"
          target="_blank"
        >
          <BaseButton plain class="lg:ml-auto">
            Bekijk op Google Maps
            <BaseIcon name="external-link" class="ml-1" />
          </BaseButton>
        </a>
      </div>
    </div>
  </MeteringPointCard>
</template>

<script setup>
import { computed, ref, watch } from "vue"
import { staticMap } from "@/services/mapboxApiService.js"
import useViewStore from "@/stores/viewStore.js"
import useFilterStore from "@/stores/filterStore.js"
import useMeteringPointsStore from "@/stores/repower/meteringPointsStore"
import { debounce, DEBOUNCE_DELAY } from "@/helpers/debounce.js"
import {
  TextSubtitle,
  BaseIcon,
  BaseButton,
  LoadingWrapper,
} from "@repowerednl/ui-component-library"
import MeteringPointCard from "@/components/panels/MeteringPointCard.vue"
import AssetInfoListComponent from "@/components/information/AssetInfoListComponent.vue"
import AllocationPointInfoListComponent from "@/components/information/AllocationPointInfoListComponent.vue"

const props = defineProps({
  meteringPoint: {
    type: Object,
    default: null,
  },
})

const viewStore = useViewStore()
const filterStore = useFilterStore()
const meteringPointsStore = useMeteringPointsStore()
const mapImage = ref()

const allocationPoint = computed(() => {
  if (!props.meteringPoint) {
    return {}
  }
  return (
    meteringPointsStore.allocationPoints.find(
      (ap) => ap.id === props.meteringPoint.allocationPointId,
    ) ?? {}
  )
})

const address = computed(() => allocationPoint.value.properties?.address)

const fetchMapImage = debounce(() => {
  if (address.value && address.value.latitude && address.value.longitude) {
    staticMap(address.value.longitude, address.value.latitude, (blob) => {
      mapImage.value = URL.createObjectURL(blob)
    })
  }
}, DEBOUNCE_DELAY)

watch(
  [
    () => props.meteringPoint,
    () => filterStore.currentPortfolio?.detailsLoaded,
  ],
  () => {
    mapImage.value = null
    fetchMapImage()
  },
  { immediate: true },
)
</script>
